import type { ProviderConfig, ProviderName } from './types';

export const PROVIDERS = {
  google: { type: 'social', connection: 'google-oauth2' },
  apple: { type: 'social', connection: 'apple' },
  microsoft: { type: 'social', connection: 'microsoft' },
  email: { type: 'passwordless', connection: 'email' },
} as const satisfies Record<ProviderName, ProviderConfig>;

export const GOOGLE_INTEGRATION_PROVIDER = {
  type: 'social',
  connection: 'google-oauth2-2',
} as const;
